import { render } from "./CustomEvent.vue?vue&type=template&id=719179ce"
import script from "./CustomEvent.vue?vue&type=script&lang=js"
export * from "./CustomEvent.vue?vue&type=script&lang=js"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__